import { useState } from 'react';
import { useAction } from './useAction';

/** The state of an "add a record" form: the fields, a way to change some of them, and Save (add, reset, close, tell the user) */
export function useAddForm<F extends { name: string }, T>(
  blank: F,
  build: (form: F) => T,
  onAdd: (item: T) => void | Promise<unknown>,
  onClose: () => void,
  done: string,
) {
  const [form, setForm] = useState(blank);
  const set = (patch: Partial<F>) => setForm((f) => ({ ...f, ...patch }));
  const add = useAction(async (item: T) => void (await onAdd(item)), {
    success: done,
    onDone: () => {
      setForm(blank);
      onClose();
    },
  });
  const save = () => add.run(build({ ...form, name: form.name.trim() }));
  return { form, set, save, busy: add.busy };
}
